module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/chevron-right-de14127c1a99110f825b98e8f236780c.svg";